<div class="sidebar-container" [class.sidebar-full-page-nav]="!mobileView">
    <ul *ngIf="mobileView" class="main-navigation-menu main-navigation-menu--nav-hilite main-navigation-menu--top">
        <li>
            <a class="sidebar-v2-link" (click)="toggleMainMenu()">
                <div class="item-content">
                    <span class="item-media mobile-close__icon mr-3"></span>
                    <span class="item-inner mobile-close__heading">Close Menu</span>
                </div>
            </a>
        </li>
    </ul>
    <ng-scrollbar>
        <nav (appClickOutsidePanels)="toggleMainMenu()" [enableClickOut]="!(isSidebarClosed$ | async) && mobileView">
            <!-- new navigation -->
            <ul class="main-navigation-menu main-navigation-menu--nav-hilite main-navigation-menu--top">
                <!-- Collapse Button -->
                <li *ngIf="!mobileView">
                    <a class="sidebar-v2-link collapse-menu-item" title="Collapse/Expand Menu" (click)="toggle()">
                        <div class="sidebar-collapse-btn">
                            <i class="icon-ic-menu org-color"></i>
                            <span class="collapse-title">
                                <img src="../assets/images/buildxact-menu-logo.png" />
                            </span>
                        </div>
                    </a>
                </li>

                <!-- Header (My Business) -->
                <li
                    [ngClass]="{
                        active:
                            routerUrl.startsWith('/account') && !routerUrl.startsWith('/account/setup/integrations') && !RouteLessPanels(),
                    }">
                    <a
                        class="sidebar-v2-link my-business"
                        title="{{ sharedData.UserData.tenant?.CompanyName }}"
                        (click)="getPrimaryLink('MyBusiness')">
                        <div class="item-content">
                            <div class="item-media collapsed-padding">
                                <i
                                    *ngIf="mobileView"
                                    class="icon-ic-profile-s1 org-color"
                                    [ngClass]="{ active: routerUrl.startsWith('/account') }"></i>
                                <div *ngIf="!mobileView" class="sidebar-v2-company-logo">
                                    <img *ngIf="logoUrl" [alt]="sharedData.UserData.tenant?.CompanyName || ''" [src]="logoUrl" />
                                </div>
                            </div>
                            <div class="item-inner" id="my-business-button">
                                <span class="title" title="{{ sharedData.UserData.tenant?.CompanyName }}"> My business</span>
                            </div>
                        </div>
                        <button *ngIf="mobileView" id="bx-menu-open" type="button" class="btn btn-toggle pull-right">
                            <i id="icon" class="icon-ic-chevron-s1" [ngClass]="{ expanded: submenuStatus.mybusiness }"></i>
                        </button>
                    </a>

                    <!-- MOBILE VIEW -->
                    <ul class="mobile-menu" *ngIf="mobileView">
                        <li
                            *ngIf="submenuStatus.mybusiness && routerUrl.startsWith('/account')"
                            class="sidebar2-radio-dropdown"
                            [ngClass]="getDropdownClasses('business-account')">
                            <app-sidebar2-radio-dropdown
                                heading="Business Account"
                                settingsFlag="NavigationV2MyBusiness"
                                defaultRoute="/account/details"
                                [defaultQueryParams]="{ submenu: 'business-account' }"
                                [options]="accountOptions['Business Account']">
                            </app-sidebar2-radio-dropdown>
                        </li>
                        <li
                            *ngIf="submenuStatus.mybusiness && routerUrl.startsWith('/account')"
                            class="sidebar2-radio-dropdown"
                            [ngClass]="getDropdownClasses('business-setup')">
                            <app-sidebar2-radio-dropdown
                                heading="Business Setup"
                                settingsFlag="NavigationV2MyBusiness"
                                defaultRoute="/account/setup/businessdocuments"
                                [defaultQueryParams]="{ submenu: 'business-setup' }"
                                [options]="accountOptions['Business Setup']">
                            </app-sidebar2-radio-dropdown>
                        </li>
                        <li>
                            <app-sidebar2-subpanel-tenants
                                sidebar2-radio-dropdown
                                *ngIf="lds.get('group-tenants') && submenuStatus.mybusiness"
                                [dropDownClasses]="getDropdownClasses('price-lists')">
                            </app-sidebar2-subpanel-tenants>
                        </li>
                        <li
                            *ngIf="submenuStatus.mybusiness && routerUrl.startsWith('/account') && showAPIWebhooks"
                            class="sidebar2-radio-dropdown"
                            [ngClass]="getDropdownClasses('business-api')">
                            <app-sidebar2-radio-dropdown
                                heading="API"
                                settingsFlag="NavigationV2MyBusiness"
                                defaultRoute="/account/api/webhooks"
                                [defaultQueryParams]="{ submenu: 'business-api' }"
                                [options]="accountOptions['Business API']">
                            </app-sidebar2-radio-dropdown>
                        </li>
                    </ul>
                </li>

                <!-- Dashboard -->
                <li
                    [ngClass]="{ active: routerUrl.startsWith('/dashboard') && !RouteLessPanels() }"
                    *ngIf="featureService.isStateAvailable('dashboard')">
                    <a routerLink="/dashboard" class="sidebar-v2-link" title="Dashboard" (click)="togglePanels()">
                        <div class="item-content">
                            <div class="item-media">
                                <i class="fa-light fa-grid-2 org-color"></i>
                            </div>
                            <div class="item-inner" id="dashboard-button">
                                <span class="title">Dashboard</span>
                            </div>
                        </div>
                    </a>
                </li>

                <!-- Leads -->
                <li
                    *ngIf="
                        featureService.isStateAvailable('leads') &&
                        permissionService.isAvailable('leads.maintain-leads.leads-menu') &&
                        permissionService.isAvailable('leads.maintain-leads.view-leads')
                    "
                    [ngClass]="{ active: routerUrl.startsWith('/leads') && !RouteLessPanels() }">
                    <a class="sidebar-v2-link" title="Leads" (click)="getPrimaryLink('Leads')">
                        <div class="item-content">
                            <div class="item-media">
                                <i class="fa-light fa-arrow-right-arrow-left org-color"></i>
                            </div>
                            <div class="item-inner" id="leads-button">
                                <span class="title">Leads</span>
                            </div>
                            <button *ngIf="mobileView" id="bx-menu-open" type="button" class="btn btn-toggle pull-right">
                                <i id="icon" class="icon-ic-chevron-s1" [ngClass]="{ expanded: submenuStatus.leads }"></i>
                            </button>
                        </div>
                    </a>
                    <!-- MOBILE VIEW -->
                    <app-sidebar2-leads-sub-menu *ngIf="mobileView && submenuStatus.leads && $state.includes('leads')">
                    </app-sidebar2-leads-sub-menu>
                </li>

                <!-- Estimates -->
                <li
                    [ngClass]="{
                        active:
                            (routerUrl.startsWith('/estimates') ||
                                (featureService.isAvailable('compact-jobs') && routerUrl.startsWith('/jobs'))) &&
                            !RouteLessPanels(),
                    }"
                    *ngIf="
                        permissionService.isAvailable('estimates.estimates-access.estimates-menu') &&
                        featureService.isStateAvailable('estimates')
                    ">
                    <a class="sidebar-v2-link" title="Estimates" (click)="getPrimaryLink('Estimates')">
                        <div class="item-content">
                            <div class="item-media">
                                <i class="fa-light fa-ruler-triangle org-color"></i>
                            </div>
                            <div class="item-inner" id="estimates-button">
                                <span class="title">Estimates</span>
                                <i class="fa fa-spinner fa-spin" title="Generating estimate..." *ngIf="processingSmartEstimate()"></i>
                                <span class="badge pull-right" *ngIf="badgeCounts.estimates > 0">{{ badgeCounts.estimates }}</span>
                            </div>
                            <button *ngIf="mobileView" id="bx-menu-open" type="button" class="btn btn-toggle pull-right">
                                <i id="icon" class="icon-ic-chevron-s1" [ngClass]="{ expanded: submenuStatus.estimates }"></i>
                            </button>
                        </div>
                    </a>
                    <!-- MOBILE VIEW -->
                    <app-sidebar2-estimates-sub-menu *ngIf="mobileView && submenuStatus.estimates && routerUrl.startsWith('/estimates')">
                    </app-sidebar2-estimates-sub-menu>
                </li>

                <!-- jobs -->
                <li
                    [ngClass]="{ active: routerUrl.startsWith('/jobs') && !RouteLessPanels() }"
                    *ngIf="permissionService.isAvailable('jobs.jobs-access.jobs-menu') && featureService.isStateAvailable('jobs')">
                    <a class="sidebar-v2-link" title="Jobs" (click)="getPrimaryLink('Jobs')">
                        <div class="item-content">
                            <div class="item-media">
                                <i class="fa-light fa-calendar org-color"></i>
                            </div>
                            <div class="item-inner" id="jobs-button">
                                <span class="title">Jobs</span>
                                <span class="badge pull-right" *ngIf="badgeCounts.jobs > 0">{{ badgeCounts.jobs }}</span>
                            </div>
                            <button *ngIf="mobileView" id="bx-menu-open" type="button" class="btn btn-toggle pull-right">
                                <i id="icon" class="icon-ic-chevron-s1" [ngClass]="{ expanded: submenuStatus.jobs }"></i>
                            </button>
                        </div>
                    </a>
                    <!-- MOBILE VIEW -->
                    <app-sidebar2-jobs-sub-menu #jobsmenu *ngIf="mobileView && submenuStatus.jobs && routerUrl.startsWith('/jobs')">
                    </app-sidebar2-jobs-sub-menu>
                </li>

                @if (isMaterialOrdersMenuAvailable()) {
                    <li (click)="showMaterialOrders()">
                        <a id="side-nav-material-orders" class="sidebar-v2-link" title="Material orders">
                            <div class="item-content">
                                <div class="item-media">
                                    <i class="fa-light fa-cart-shopping org-color"></i>
                                </div>
                                <div class="item-inner" id="material-orders-button">
                                    <span class="title">Material orders</span>
                                </div>
                            </div>
                        </a>
                    </li>
                }
                @if (!withSeeMore() || showMore() || mobileView) {
                    <!-- Request for Quotes -->
                    <li
                        [ngClass]="{ active: routerUrl.startsWith('/quoterequests') && !RouteLessPanels() }"
                        *ngIf="
                            permissionService.isAvailable('request-for-quote.rfq-access.rfq-menu') &&
                            featureService.isStateAvailable('quoterequests') &&
                            showRfqMenuOption
                        ">
                        <a class="sidebar-v2-link" title="Request For Quotes" (click)="getPrimaryLink('QuoteRequests')">
                            <div class="item-content">
                                <div class="item-media">
                                    <i class="fa-light fa-file-invoice-dollar org-color"></i>
                                </div>
                                <div class="item-inner" id="quoterequests-button">
                                    <span class="title">Request for quotes</span>
                                    <span class="badge pull-right" *ngIf="badgeCounts.rfqs > 0">{{ badgeCounts.rfqs }}</span>
                                </div>
                                <button *ngIf="mobileView" id="bx-menu-open" type="button" class="btn btn-toggle pull-right">
                                    <i id="icon" class="icon-ic-chevron-s1" [ngClass]="{ expanded: submenuStatus.quoterequests }"></i>
                                </button>
                            </div>
                        </a>
                        <!-- MOBILE VIEW -->
                        <app-sidebar2-rfq-sub-menu
                            *ngIf="mobileView && submenuStatus.quoterequests && routerUrl.startsWith('/quoterequests')">
                        </app-sidebar2-rfq-sub-menu>
                    </li>

                    <!-- Clients -->
                    <li
                        [ngClass]="{ active: routerUrl.startsWith('/customers') && !RouteLessPanels() }"
                        *ngIf="
                            permissionService.isAvailable('customers.customers-access.customers-menu') &&
                            featureService.isStateAvailable('customers')
                        ">
                        <a class="sidebar-v2-link" title="Clients" (click)="getPrimaryLink('Clients')">
                            <div class="item-content">
                                <div class="item-media">
                                    <i class="fa-light fa-user org-color"></i>
                                </div>
                                <div class="item-inner" id="customers-button">
                                    <span class="title">Clients</span>
                                    <span class="badge pull-right" *ngIf="requestedCount > 0">{{ requestedCount }}</span>
                                </div>
                                <button *ngIf="mobileView" id="bx-menu-open" type="button" class="btn btn-toggle pull-right">
                                    <i id="icon" class="icon-ic-chevron-s1" [ngClass]="{ expanded: submenuStatus.clients }"></i>
                                </button>
                            </div>
                        </a>
                        <!-- MOBILE VIEW -->
                        <app-sidebar2-clients-sub-menu *ngIf="mobileView && submenuStatus.clients && routerUrl.startsWith('/customers')">
                        </app-sidebar2-clients-sub-menu>
                    </li>

                    <!-- Contacts -->
                    <li
                        [ngClass]="{ active: routerUrl.startsWith('/contacts') && !RouteLessPanels() }"
                        *ngIf="
                            permissionService.isAvailable('contacts.contacts-access.contacts-menu') &&
                            featureService.isStateAvailable('contacts')
                        ">
                        <a class="sidebar-v2-link" title="Contacts" (click)="getPrimaryLink('Contacts')">
                            <div class="item-content">
                                <div class="item-media">
                                    <i class="fa-light fa-address-book org-color"></i>
                                </div>
                                <div class="item-inner" id="contacts-button">
                                    <span
                                        class="title"
                                        [ngClass]="{
                                            'title--with-badge':
                                                sharedData.ContactCardStatus?.expiring || sharedData.ContactCardStatus?.expired,
                                        }"
                                        >Contacts</span
                                    >

                                    <span
                                        class="badge pull-right"
                                        *ngIf="sharedData.ContactCardStatus?.expiring || sharedData.ContactCardStatus?.expired"
                                        [ngClass]="{
                                            'badge-warning':
                                                sharedData.ContactCardStatus?.expiring && !sharedData.ContactCardStatus?.expired,
                                            'badge-danger': sharedData.ContactCardStatus?.expired,
                                        }"
                                        >{{
                                            (sharedData.ContactCardStatus?.expiring ?? 0) + (sharedData.ContactCardStatus?.expired ?? 0)
                                        }}</span
                                    >
                                </div>
                                <button *ngIf="mobileView" id="bx-menu-open" type="button" class="btn btn-toggle pull-right">
                                    <i id="icon" class="icon-ic-chevron-s1" [ngClass]="{ expanded: submenuStatus.contacts }"></i>
                                </button>
                            </div>
                        </a>
                        <!-- MOBILE VIEW -->
                        <app-sidebar2-contacts-sub-menu *ngIf="mobileView && submenuStatus.contacts && routerUrl.startsWith('/contacts')">
                        </app-sidebar2-contacts-sub-menu>
                    </li>

                    <!-- Communications -->
                    <li
                        [ngClass]="{
                            active: routerUrl.startsWith('/messages') && !RouteLessPanels(),
                        }"
                        *ngIf="
                            permissionService.isAvailable('messages.messages-access.messages-menu') &&
                            featureService.isStateAvailable('messages')
                        ">
                        <a class="sidebar-v2-link" title="Communications" (click)="getPrimaryLink('Communications')">
                            <div class="item-content">
                                <div class="item-media">
                                    <i class="fa-light fa-comment org-color"></i>
                                </div>
                                <div class="item-inner" id="communications-button">
                                    <span class="title" [ngClass]="{ 'title--with-badge': combinedMessageBadgeCount }">Communications</span>
                                    <span class="badge pull-right" *ngIf="combinedMessageBadgeCount">{{
                                        combinedMessageBadgeCount | number
                                    }}</span>
                                </div>
                                <button *ngIf="mobileView" id="bx-menu-open" type="button" class="btn btn-toggle pull-right">
                                    <i id="icon" class="icon-ic-chevron-s1" [ngClass]="{ expanded: submenuStatus.communications }"></i>
                                </button>
                            </div>
                        </a>
                        <!-- MOBILE VIEW -->
                        <ul class="mobile-menu">
                            <li
                                *ngIf="mobileView && submenuStatus.communications && routerUrl.startsWith('/messages')"
                                class="sidebar2-radio-dropdown"
                                [ngClass]="getDropdownClasses('communications')">
                                <app-sidebar2-radio-dropdown
                                    heading=""
                                    settingsFlag="NavigationV2Communications"
                                    defaultRoute="/messages/email"
                                    [defaultQueryParams]="{ submenu: 'communications' }"
                                    [options]="communicationsOptions?.Communications">
                                </app-sidebar2-radio-dropdown>
                            </li>
                        </ul>
                    </li>

                    <!-- Catalogues -->
                    <li
                        [ngClass]="{ active: routerUrl.startsWith('/price') && !RouteLessPanels() }"
                        *ngIf="
                            permissionService.isAvailable('pricing.pricing-access.pricing-menu') &&
                            featureService.isStateAvailable('pricing')
                        ">
                        <a class="sidebar-v2-link" title="Catalogues" (click)="getPrimaryLink('Catalogues')">
                            <div class="item-content">
                                <div class="item-media">
                                    <i class="fa-light fa-cabinet-filing org-color"></i>
                                </div>
                                <div id="pricing-button" class="item-inner">
                                    <span class="title">{{ 'catalogues.catalogues' | translate }}</span>
                                    <span class="badge pull-right" *ngIf="badgeCounts.catalogues > 0">{{ badgeCounts.catalogues }}</span>
                                    <i class="fa fa-circle-o-notch fa-spin pull-left" title="Importing items..." *ngIf="importingItems"></i>
                                </div>
                                <button *ngIf="mobileView" id="bx-menu-open" type="button" class="btn btn-toggle pull-right">
                                    <i id="icon" class="icon-ic-chevron-s1" [ngClass]="{ expanded: submenuStatus.catalogues }"></i>
                                </button>
                            </div>
                        </a>

                        <!-- Mobile view -->
                        <sidebar2-subpanel-catalogues
                            *ngIf="mobileView && submenuStatus.catalogues && routerUrl.startsWith('/price')"
                            routeLessPanels="RouteLessPanels">
                        </sidebar2-subpanel-catalogues>
                    </li>

                    <!-- Integrations -->
                    <li
                        [ngClass]="{
                            active:
                                settings.ShowIntegrationsPanel ||
                                routerUrl.startsWith('/integrations') ||
                                routerUrl.startsWith('/account/setup/integrations'),
                        }"
                        *ngIf="permissionService.isAvailable('account.maintain-integrations.integrations-menu') && allowIntegrations">
                        <a class="sidebar-v2-link" title="Integrations" (click)="getPrimaryLink('Integrations')">
                            <div class="item-content">
                                <div class="item-media">
                                    <i class="fa-light fa-plug org-color"></i>
                                </div>
                                <div class="item-inner" id="integrations-button">
                                    <span class="title" [ngClass]="{ 'title--with-badge': false }">Integrations</span>
                                    <span *ngIf="integrationsErrors" class="pull-right">
                                        <i class="alert-icon"></i>
                                    </span>
                                    <span
                                        class="badge pull-right"
                                        *ngIf="
                                            (integrationsNotificationsCount ||
                                                badgeCounts.applicationIntegrations ||
                                                badgeCounts.integrations) &&
                                            !integrationsErrors
                                        ">
                                        {{
                                            (integrationsNotificationsCount ? integrationsNotificationsCount : 0) +
                                                (badgeCounts.applicationIntegrations ? badgeCounts.applicationIntegrations : 0) +
                                                (badgeCounts.integrations ? badgeCounts.integrations : 0)
                                        }}</span
                                    >
                                </div>
                            </div>
                            <button *ngIf="mobileView" id="bx-menu-open" type="button" class="btn btn-toggle pull-right">
                                <i id="icon" class="icon-ic-chevron-s1" [ngClass]="{ expanded: submenuStatus.integrations }"></i>
                            </button>
                        </a>

                        <!-- MOBILE VIEW -->
                        <ul class="mobile-menu">
                            <li>
                                <app-sidebar2-subpanel-integrations *ngIf="mobileView && submenuStatus.integrations">
                                </app-sidebar2-subpanel-integrations>
                            </li>
                            <li
                                class="sidebar2-dropdown active"
                                *ngIf="mobileView && submenuStatus.integrations && integrationsActive"
                                [ngClass]="{ open: toggle_Connections }">
                                <header (click)="fnToggleIntegrationsConnections()" class="sub-menu-v2--header">
                                    <label>Connections</label>
                                    <i class="icon-ic-chevron-s1 icon-ic-chevron--expandable"></i>
                                </header>
                                <app-integrations-active *ngIf="toggle_Connections"></app-integrations-active>
                            </li>
                        </ul>
                    </li>

                    <li *ngIf="mobileView && isTodoAvailable" (click)="showTodoList()">
                        <a id="side-nav-todo-list" title="To-do list" class="sidebar-v2-link btn-side-nav-todo-list">
                            <div class="item-content">
                                <div class="item-media">
                                    <i class="fa-light fa-list-check org-color"></i>
                                </div>
                                <div class="item-inner" id="side-nav-todo-list-button">
                                    <span class="title">To-do list</span>
                                </div>
                            </div>
                        </a>
                    </li>

                    <li [ngClass]="{ active: routerUrl.startsWith('/preview-features') && !RouteLessPanels() }">
                        <a
                            id="side-nav-preview-features"
                            routerLink="/preview-features"
                            class="sidebar-v2-link"
                            title="Preview Features"
                            (click)="togglePanels()">
                            <div class="item-content">
                                <div class="item-media">
                                    <i class="fa-light fa-star org-color rotated-15deg"></i>
                                </div>
                                <div class="item-inner" id="labs">
                                    <span class="title">Preview features</span>
                                </div>
                            </div>
                        </a>
                    </li>
                }
                <li *ngIf="mobileView" [ngClass]="{ active: settings.ShowMyProfilePanel }">
                    <a class="sidebar-v2-link my-business" (click)="fnShowMyProfilePanel()">
                        <div class="item-content">
                            <div class="item-media">
                                <i class="icon-ic-profile-s1 org-color" [ngClass]="{ active: settings.ShowMyProfilePanel }"></i>
                            </div>
                            <div class="item-inner" id="my-profile-button">
                                <span class="title">My profile</span>
                                <span class="badge badge-danger pull-right" *ngIf="sharedData.UserData.tenant?.DisplayPaymentIssue">!</span>
                            </div>
                        </div>
                        <button id="bx-menu-open" type="button" class="btn btn-toggle pull-right">
                            <i id="icon" class="icon-ic-chevron-s1" [ngClass]="{ expanded: settings.ShowMyProfilePanel }"></i>
                        </button>
                    </a>

                    <!-- MOBILE VIEW -->
                    <ul class="mobile-menu">
                        <li *ngIf="mobileView && settings.ShowMyProfilePanel" class="sidebar2-dropdown">
                            <app-form-my-profile></app-form-my-profile>
                            <header (click)="fnSignOut()" class="sub-menu-v2--header">
                                <i class="icon-ic-signout-s1 heading-logo"></i>
                                <label>Log Out</label>
                            </header>
                        </li>
                    </ul>
                </li>

                <!-- Need Help  -->
                <li *ngIf="mobileView && canSeeIntercom" (click)="clearPanels()" [ngClass]="{ active: settings.ChatActive }">
                    <a id="intercom-launcher" class="sidebar-v2-link btn-intercom-launcher">
                        <div class="item-content">
                            <div class="item-media">
                                <i class="icon-ic-chat-with-us-s1 icon-outline org-color"></i>
                                <i class="icon-ic-chat-with-us-s2 icon-filled org-color"></i>
                            </div>
                            <div class="item-inner" id="chat-button">
                                <span class="title">Need help?</span>
                                <span class="badge pull-right" *ngIf="appSettings.unreadIntercomCount > 0">{{
                                    appSettings.unreadIntercomCount
                                }}</span>
                            </div>
                        </div>
                    </a>
                </li>

                <!-- Explore  -->
                <li *ngIf="mobileView" [ngClass]="{ active: settings.ShowExplorePanel }">
                    <a class="sidebar-v2-link" title="Explore" (click)="fnShowExplorePanel()">
                        <div class="item-content">
                            <div class="item-media">
                                <i class="icon-ic-explore-s1 org-color icon-outline"></i>
                                <i class="icon-ic-explore-s2 org-color icon-filled"></i>
                            </div>
                            <div class="item-inner" id="explore-button">
                                <span class="title">
                                    @if (exploreMoreWithResources()) {
                                        Community
                                    } @else {
                                        Explore
                                    }
                                </span>
                            </div>
                        </div>
                        <button id="bx-menu-open" type="button" class="btn btn-toggle pull-right">
                            <i id="icon" class="icon-ic-chevron-s1" [ngClass]="{ expanded: settings.ShowExplorePanel }"></i>
                        </button>
                    </a>
                </li>
                <!-- MOBILE VIEW -->
                <app-sidebar2-explore-sub-menu *ngIf="mobileView && settings.ShowExplorePanel"> </app-sidebar2-explore-sub-menu>

                @if (withSeeMore() && !mobileView) {
                    @let title = 'See ' + (showMore() ? 'less' : 'more');
                    <li (click)="toggleSeeMore()" class="side-nav-show-more">
                        <a id="side-nav-show-more" [title]="title" class="sidebar-v2-link btn-side-nav-show-more">
                            <div class="item-content">
                                <div class="item-media">
                                    <i class="fa-light fa-ellipsis-stroke org-color"></i>
                                </div>
                                <div class="item-inner" id="side-nav-show-more-button">
                                    <span class="title">{{ title }}</span>
                                </div>
                            </div>
                        </a>
                    </li>
                }
            </ul>
        </nav>
    </ng-scrollbar>
    <div *ngIf="!mobileView" class="bottom-grad"></div>
</div>

<div *ngIf="!mobileView" class="sidebar-bottom">
    <ul class="main-navigation-menu main-navigation-menu--nav-hilite main-navigation-menu--bottom">
        <!-- My Profile  -->
        <li [ngClass]="{ active: settings.ShowMyProfilePanel }" (click)="fnShowMyProfilePanel()">
            <a class="sidebar-v2-link my-business">
                <div class="item-content">
                    <app-bx-user-avatar [avatarInfo]="avatarInfo"></app-bx-user-avatar>
                    <div class="item-inner" id="my-profile-button">
                        <span class="title">My Profile</span>
                        <span class="badge badge-danger pull-right" *ngIf="sharedData.UserData.tenant?.DisplayPaymentIssue">!</span>
                    </div>
                </div>
            </a>
        </li>

        <!-- Need Help  -->
        <li *ngIf="canSeeIntercom" (click)="clearPanels()" [ngClass]="{ active: settings.ChatActive }">
            <a id="intercom-launcher" class="sidebar-v2-link active btn-intercom-launcher">
                <div class="item-content">
                    <div class="item-media">
                        <i class="icon-ic-chat-with-us-s1 icon-outline org-color"></i>
                        <i class="icon-ic-chat-with-us-s2 icon-filled org-color"></i>
                    </div>
                    <div class="item-inner" id="chat-button">
                        <span class="title">Need Help?</span>
                        <span class="badge pull-right" *ngIf="appSettings.unreadIntercomCount > 0">{{
                            appSettings.unreadIntercomCount
                        }}</span>
                    </div>
                </div>
            </a>
        </li>

        <!-- To-do List -->
        <li *ngIf="isTodoAvailable" (click)="showTodoList()">
            <a id="side-nav-todo-list" title="To-do list" class="sidebar-v2-link btn-side-nav-todo-list">
                <div class="item-content">
                    <div class="item-media">
                        <i class="fa-light fa-list-check org-color"></i>
                    </div>
                    <div class="item-inner" id="side-nav-todo-list-button">
                        <span class="title">To-do list</span>
                    </div>
                </div>
            </a>
        </li>

        <!-- Explore  -->
        <li [ngClass]="{ active: settings.ShowExplorePanel }">
            <a class="sidebar-v2-link" title="Explore" (click)="fnShowExplorePanel()">
                <div class="item-content">
                    <div class="item-media">
                        <i class="icon-ic-explore-s1 icon-outline org-color"></i>
                        <i class="icon-ic-explore-s2 icon-filled org-color"></i>
                    </div>
                    <div class="item-inner" id="explore-button">
                        <span class="title">
                            @if (exploreMoreWithResources()) {
                                Community
                            } @else {
                                Explore
                            }
                        </span>
                    </div>
                </div>
            </a>
        </li>
    </ul>
</div>
